import { connect } from 'react-redux';
import { withStyles } from '@mui/styles';
import Market from './Market';
import styles from './styles';

function mapStateToProps(state) {
  const {
    isLoading, data, forSale, paidItem, fixedPrice, auctions, cart,
  } = state.market;
  return {
    isLoading,
    data,
    forSale,
    paidItem,
    fixedPrice,
    auctions,
    cart,
  };
}

const Styled = withStyles(styles)(Market);

export default connect(
  mapStateToProps,
)(Styled);
